import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import { API_BASE_URLS } from "../../utils/constant";
import axiosInstance from "../../utils/axios";
import { FileDataType } from "../../@customTypes/file";

type FileState = {
  isLoading: boolean;
  error: boolean;
  success: boolean;
  fileList: FileDataType[];
  selectedFile: FileDataType | null;
};

const initialState: FileState = {
  isLoading: false,
  error: false,
  success: false,
  fileList: [],
  selectedFile: null
};

const slice = createSlice({
  name: "file",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // IS SUCCESS
    isSuccess(state, action) {
      state.isLoading = false;
      state.success = action.payload;
    },
    // ZONE LISTING
    getFileListSuccess(state, action) {
      state.isLoading = false;
      state.fileList = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export function getFileList({
  companyId,
  payload
}: {
  companyId: number;
  payload: any;
}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response: any = await axiosInstance.post(
        `${API_BASE_URLS.company}/${companyId}${API_BASE_URLS.file_list}`,
        payload
      );
      if (response?.error) {
        throw new Error(response?.error);
      } else dispatch(slice.actions.getFileListSuccess(response.data));
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function addFile({
  companyId,
  payload
}: {
  companyId: number;
  payload: any;
}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    // const access = localStorage.getItem("accessToken");
    //BUG: IMAGE IS NOT BEING UPLOADED
    try {
      const response: any = await axiosInstance.post(
        `${API_BASE_URLS.company}/${companyId}${API_BASE_URLS.file_add}/base64`,
        payload
      );
      if (response?.error) {
        throw new Error(response?.error);
      }
      return response.data;
    } catch (error: any) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error.message);
    }
  };
}

export function startLoading() {
  return async () => dispatch(startLoading);
}

export function stopLoading() {
  return async () => dispatch(stopLoading);
}

export function removeError() {
  return async () => dispatch(slice.actions.hasError(false));
}

export function setSuccess(payload: boolean) {
  return async () => dispatch(slice.actions.isSuccess(payload));
}
